<template>
  <div id="trainer-groups">
    <b-container id="trainer-groups-table" fluid>
      <b-row class="mt-4">
        <b-col cols="5">
          <br />
          <b-col>
            <h4 class="subtitle">
              Trainer's Current Groups ({{ groupsTable.length }})
            </h4>
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-table
              v-cloak
              responsive
              :fields="trainerGroupsFields"
              :items="groupsTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(name)" slot-scope="row" v-if="groupsTable">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditGroup',
                    params: { id: row.item.uuid },
                  }"
                  >{{ row.item.name }}</b-link
                >
              </template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.uuid"
                  v-if="isAdmin || isSRC"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateTrainerGroup(row)"
                >
                  <b-form-radio :value="true">True</b-form-radio>
                  <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  v-if="isAdmin || isSRC"
                  @click.stop="deleteTrainerGroup(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col></b-col>
        <b-col cols="5">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Groups</h4>
            <small>
              If you do not see the group you
              <br />want to add, please ensure the group <br />is added to the
              trainer
            </small>
            <br />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TrainerService from "../services/TrainerService";
import GroupService from "../services/GroupService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "TrainerGroups",
  mixins: [flash, scrollTo],
  data() {
    return {
      trainerId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      country: "",
      region: "",
      district: "",
      village: "",
      trainerGroupsFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      totalRows: this.rows,
    };
  },
  methods: {
    ...mapActions({
      GET_TRAINER_GROUPS: "trainers/GET_TRAINER_GROUPS",
      RESET_TRAINERS_STATE: "trainers/RESET_TRAINERS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
   
  async updateTrainerGroup(params) {
      const payload = await {
        id: params.item.uuid,
        active: !params.item.active,
      };
      const res = await GroupService.updateGroupActive(payload);
      await this.GET_TRAINER_GROUPS();
     
    },
    async addGroupToTrainer(params) {
      const payload = await {
        group_id: params.item.group_id,
        group_uuid: params.item.group_uuid,
        trainer_uuid: this.$route.params.id,
        active: true,
      };
      await TrainerService.addTrainerGroup(payload);
      await this.scrollTo("trainer-groups-alert");
      await this.flashSuccess();
      await this.GET_TRAINER_GROUPS();
    },
    async deleteTrainerGroup(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this group from this trainer?"
      );
      if (confirmDelete) {
        const payload = {groupUuid:params.uuid, trainerUuid: this.$route.params.id}
        await TrainerService.deleteTrainerGroup(payload);
        await this.GET_TRAINER_GROUPS();
      }
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    groups: {
      get() {
        // add some stuff to clean this up
        return this.$store.state.trainers.trainerGroups;
      },
    },
    groupsTable() {
      const groups = this.groups.map((k) => ({
        id: k.id,
        uuid: k.uuid,
        name: k.group_name,
        active: k.active,
      }));
      return groups;
    },
    rows() {
      return this.groups.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.trainerGroupsFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.GET_TRAINER_GROUPS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}
.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
